// extracted by mini-css-extract-plugin
export default {"review":"Review_review__AC7Vo","head":"Review_head__75MAY","logo":"Review_logo__3dmkP","info":"Review_info__QJkCw","body":"Review_body__uj1tR","content":"Review_content__lYiKT"};